import React from "react";

const PanelSidebar = ({ activeMenu, setActiveMenu, user }) => {


  const SIDEBAR_MENUS = [
    { key: "dashboard", label: "Dashboard", icon: "📊" },
    { key: "users", label: "Users", icon: "👥" },
    { key: "sliders", label: "Sliders", icon: "🖼️" },
    { key: "products", label: "Products", icon: "📦" },
    { key: "categories", label: "Categories", icon: "🗂️" },
    { key: "brands", label: "Brands", icon: "🏷️" },
    { key: "testimonials", label: "Testimonials", icon: "💬" },
    { key: "contact", label: "Contact Queries", icon: "📨" },
    { key: "upload", label: "Upload Files", icon: "📤" },
    { key: "teams", label: "Teams Members", icon: "👥" },
    { key: "dealers", label: "Dealers", icon: "📦" },
    { key: "maintenance", label: "Maintenance", icon: "🛠️" },
    { key: "settings", label: "Settings", icon: "⚙️" },
    { key: "profile", label: "Profile", icon: "👤" },
  ];



  // return (
  //   <div style={styles.sidebar}>
  //     <h2 style={styles.title}>Admin Panel</h2>

  //     {SIDEBAR_MENUS.map((menu) => (
  //       <button
  //         key={menu.key}
  //         style={activeMenu === menu.key ? styles.activeBtn : styles.btn}
  //         onClick={() => setActiveMenu(menu.key)}
  //       >
  //         <span style={styles.icon}>{menu.icon}</span>
  //         {menu.label}
  //       </button>
  //     ))}
  //   </div>
  // );
  return (
  <div style={styles.sidebar}>
    <h2 style={styles.title}>Admin Panel</h2>

    {/* Scrollable menu area */}
    <div style={styles.menuContainer}>
      {SIDEBAR_MENUS.map((menu) => (
        <button
          key={menu.key}
          style={activeMenu === menu.key ? styles.activeBtn : styles.btn}
          onClick={() => setActiveMenu(menu.key)}
        >
          <span style={styles.icon}>{menu.icon}</span>
          {menu.label}
        </button>
      ))}
    </div>
  </div>
);
};

const styles = {
  sidebar: {
    width: "260px",
    backgroundColor: "#1a1f36",
    color: "white",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    height: "100vh",
  },

  title: {
    marginBottom: "16px",
    fontSize: "22px",
    textAlign: "center",
    flexShrink: 0, // prevents shrinking
  },

  menuContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    overflowY: "auto",      // ✅ scrolling
    flex: 1,                // ✅ fills remaining space
    paddingRight: "6px",    // space for scrollbar
  },

  btn: {
    padding: "12px",
    backgroundColor: "#2a3148",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    textAlign: "left",
    flexShrink: 0,          // buttons don’t collapse
  },

  activeBtn: {
    padding: "12px",
    backgroundColor: "#4a63e7",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    textAlign: "left",
    flexShrink: 0,
  },

  icon: {
    marginRight: "8px",
  },
};
export default PanelSidebar;
